$(document).ready(function () {
  var config = {
    default_latitude: "24.9170147, ",
    default_longitude: "67.0551122",
    default_no_of_markers: "500",
    max_no_of_markers: "5",
    distance_for_filter: "10",
  };

   var locations = [
    {
      title: "Abdul Rehman Book Bank",
      description: "",
      phone: "(051) 5147031",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548251829scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Grand Trunk Rd, Sector C Sector A DHA Phase II, Rawalpindi, Islamabad, Islamabad Capital Territory 46000",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.5216802914556,
      longitude: 73.15461189757093,
      extrafield: "",
      status: 1,
    },
    {
      title: "Global Books",
      description: "",
      phone: "(051) 2112526",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548251829scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Trade Centre, Shop 5, Basement, Plot 18, Hilal Rd S, F-11 Markaz, Islamabad",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.683178538258616,
      longitude: 72.98817475784185,
      extrafield: "",
      status: 1,
    },
    {
      title: "The Bag Shop",
      description: "",
      phone: "(022) 3821368",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548251829scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Opposite Mehmood Garden autoban road, Hyderabad",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Hyderabad",
      zipcode: null,
      latitude: 25.374637646461288,
      longitude: 68.35049499737015,
      extrafield: "",
      status: 1,
    },
    {
      title: "Zia Book Sellers",
      description: "",
      phone: "(041) 8732670",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548251829scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "478, D Ground, Peoples Colony, Faislabad",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Faisalabad",
      zipcode: null,
      latitude: 31.4053155,
      longitude: 73.1098892,
      extrafield: "",
      status: 1,
    },
    {
      title: "Anwaria Kitab Ghar",
      description: "",
      phone: "(051) 4510189",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548344051scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "89 Post Office Road Wah Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Rawalpindi",
      zipcode: null,
      latitude: 33.7842816,
      longitude: 72.7272956,
      extrafield: "",
      status: 1,
    },
    {
      title: "Aryan`s Stationary & Gift Shop",
      description: "",
      phone: "(021) 35861735",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548344243scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Shop# 1, Marine Point, D.C.I Block-9, Main Clifton, Karachi",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.8273294,
      longitude: 67.0361798,
      extrafield: "",
      status: 1,
    },
    {
      title: "Book City",
      description: "",
      phone: "(081) 2836644",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548344906scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Shop # 3, Gulistan Road, Quetta Cant",
      address2: "",
      country: "Pakistan",
      state: "Balochistan",
      city: "Quetta",
      zipcode: null,
      latitude: 30.1993997,
      longitude: 67.0204019,
      extrafield: "",
      status: 1,
    },
    {
      title: "Book Juction",
      description: "",
      phone: "(051) 5500830",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548401956scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Al-Rehman Book Junction & Gift Spot, Chaklala 3, Chaklala, Chaklala Scheme 3 Chaklala Housing Scheme 3, Rawalpindi, Punjab 46000",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Rawalpindi",
      zipcode: null,
      latitude: 33.5858602,
      longitude: 73.0879741,
      extrafield: "",
      status: 1,
    },
    {
      title: "Defence Book Centre",
      description: "",
      phone: "(042) 35897035",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548402556scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Qazi Plaza, Defence Chowk, Walton Road, Lahore Cantt",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.494609,
      longitude: 74.374402,
      extrafield: "",
      status: 1,
    },
    {
      title: "Idris Book Bank Too",
      description: "",
      phone: "(051) 5568898",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548411181scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Shop # 1, Basement, Al-Feroz Mall, Main PWD Road, Islamabad.",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.6893911,
      longitude: 73.0519851,
      extrafield: "",
      status: 1,
    },
    {
      title: "Idris Book Bank Too DHA 2",
      description: "",
      phone: "(051) 8448496",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548411181scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Idris Book Bank Too DHA 2, Shop No 1, Idris Arcade, Jinaah Boulevard, main G.T. Rd, DHA 2 Sector A West, Islamabad, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.5338855,
      longitude: 73.0468281,
      extrafield: "",
      status: 1,
    },
    {
      title: "Iqbal Book Corner",
      description: "",
      phone: "(042) 35712386",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548411329scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Main market Gulberg II, Lahore",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.524078,
      longitude: 74.3466504,
      extrafield: "",
      status: 1,
    },
    {
      title: "Kids Care",
      description: "",
      phone: "021-35147538",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548411709scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "2nd Floor, Emerald Mall, 2 Talwar, Clifton, Karachi",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.8219406,
      longitude: 67.0340521,
      extrafield: "",
      status: 1,
    },
    {
      title: "BOOK OCEAN",
      description: "",
      phone: "0322-2549902",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548411709scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Shop # 3, Plot # 79-E, 9th Commercial St, Phase IV Defence Housing Authority, Karachi, 75500",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.8226891,
      longitude: 67.0630453,
      extrafield: "",
      status: 1,
    },
    {
      title: "School Shop",
      description: "",
      phone: "042-35891893",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags\\",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548923889scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "37-G Basement Phase 1 D.H.A Lahore",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.474653,
      longitude: 74.4005748,
      extrafield: "",
      status: 1,
    },
    {
      title: "Tariq Book Town",
      description: "",
      phone: "(021) 36649425",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1548925075scasl1519633539berrybags-dealercompact_compact.jpg",
      marker_image: "",
      address: "Saman Garden, Hyderi North Nazimabad, Karachi",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.9367346,
      longitude: 67.0422094,
      extrafield: "",
      status: 1,
    },
    // {
    //   title: "Students Books & Uniform",
    //   description: "",
    //   phone: "0515516918, 0515567305",
    //   priority: 1,
    //   email: "",
    //   fax: "",
    //   web: "",
    //   webdisplay: "",
    //   tags: "Bags",
    //   schedule: "",
    //   store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1551345795scasl1548925075scasl1519633539berrybags-dealercompactcompact_compact.jpg",
    //   marker_image: "",
    //   address: "Shop# M44\\/F, Near Ramzan Plaza, Bank Road, Saddar, Rawalpindi.",
    //   address2: "",
    //   country: "Pakistan",
    //   state: "Punjab",
    //   city: "Rawalpindi",
    //   zipcode: null,
    //   latitude: 33.596381,
    //   longitude: 73.051502,
    //   extrafield: "",
    //   status: 1,
    // },
    {
      title: "Book Mark (Bahria Town Lahore)",
      description: "",
      phone: "4347863391",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1551348218scasl1548925075scasl1519633539berrybags-dealercompactcompact_compact.jpg",
      marker_image: "",
      address: "139-A, Sector C, Amaar Heights, Opposite Ravi Restaurant, Bahria Town, Lahore.",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.3751202,
      longitude: 74.1848977,
      extrafield: "",
      status: 1,
    },
    {
      title: "Book Mark (Valancia Town Lahore)",
      description: "",
      phone: "4235224732",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1551348407scasl1548925075scasl1519633539berrybags-dealercompactcompact_compact.jpg",
      marker_image: "",
      address: " Shop No.4,5,6,7 khan Arcade, 1-A1, Commercial Zone Valancia Town, Lahore. (Basement ice link, Amir Pharmancy)",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.4156638,
      longitude: 74.2610647,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "",
      phone: "(061) 6222286",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1551349110scasl1548925075scasl1519633539berrybags-dealercompactcompact_compact.jpg",
      marker_image: "",
      address: "Qasim Road, Saddar Multan Cantt Commercial Area, Multan, Punjab",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Multan",
      zipcode: null,
      latitude: 30.1894001,
      longitude: 71.4368276,
      extrafield: "",
      status: 1,
    },
    // {
    //   title: "Reads The School Shop",
    //   description: "",
    //   phone: "041-8724721",
    //   priority: 1,
    //   email: "",
    //   fax: "",
    //   web: "",
    //   webdisplay: "",
    //   tags: "Bags",
    //   schedule: "",
    //   store_image: "//cdn.shopify.com/s/files/1/2291/6531/t/4/assets/scasl_1551349459scasl1548925075scasl1519633539berrybags-dealercompactcompact_compact.jpg",
    //   marker_image: "",
    //   address: "Iqra Plaza, Main Susan Road, Faisalabad ",
    //   address2: "",
    //   country: "Pakistan",
    //   state: "Punjab",
    //   city: "Faisalabad",
    //   zipcode: null,
    //   latitude: 31.4796799,
    //   longitude: 73.0858477,
    //   extrafield: "",
    //   status: 1,
    // },
    {
      title: "Clifton Book Stall",
      description: "",
      phone: "0346 2282813",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Clifton Book Stall, Block 5 Clifton, Karachi, Karachi City, Sindh 75600",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "karachi",
      zipcode: 75600,
      latitude: 24.8260602,
      longitude: 67.03119679999998,
      extrafield: "",
      status: 1,
    },
    {
      title: "Tariq book house",
      description: "",
      phone: "",
      priority: 1,
      email: "",
      fax: "(021) 34121132",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Jamaluddin Afghani Rd, CP & Berar Society BMCHS Sharafabad, Karachi, Karachi City, Sindh",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "KARACHI",
      zipcode: null,
      latitude: 24.8840402,
      longitude: 67.06457810000006,
      extrafield: "",
      status: 1,
    },
    {
      title: "New Tariq Book Stall",
      description: "",
      phone: "(021) 34555918",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Tariq Book Stall, 451 Allama Iqbal Rd, P.E.C.H.S Block 2 Karachi, Karachi City, Sindh,",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.872227,
      longitude: 67.0587568,
      extrafield: "",
      status: 1,
    },
    {
      title: "Paper Clip ",
      description: "",
      phone: "0307 3331414",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Shop #3, Fountain Avenue, Main Boulevard, Dr Mateen Fatima Rd, Lahore",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "lahore",
      zipcode: null,
      latitude: 31.527408,
      longitude: 74.35051220000003,
      extrafield: "",
      status: 1,
    },
    {
      title: "Khursheed Book Centre",
      description: "",
      phone: "03219753008",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Khurshid Book Center sadar bazar nowshera cantt, 195-Saddar Bazar، Nowshera, Khyber Pakhtunkhwa",
      address2: "",
      country: "Pakistan",
      state: "North-West Frontier Province",
      city: "Nowshera",
      zipcode: null,
      latitude: 34.0017786,
      longitude: 71.9886097,
      extrafield: "",
      status: 1,
    },
    // {
    //   title: "The Book Land",
    //   description: "Shop # 5-6, Iqbal Stadium, Faisalabad",
    //   phone: "03097233323",
    //   priority: 1,
    //   email: "",
    //   fax: "",
    //   web: "",
    //   webdisplay: "",
    //   tags: "",
    //   schedule: "",
    //   store_image: "",
    //   marker_image: "",
    //   address: "The Book Land, Faisalabad Cricket Stadium, Civil Lines, Faisalabad, Punjab",
    //   address2: "",
    //   country: "Pakistan",
    //   state: "Punjab",
    //   city: "Faisalabad",
    //   zipcode: null,
    //   latitude: 31.4334081,
    //   longitude: 73.0826828,
    //   extrafield: "",
    //   status: 1,
    // },
    {
      title: "Azeem Books",
      description: "Abdul Haque Rd, Block G1 Block G 1 Phase 1 Johar Town, Lahore",
      phone: "+92 42 35302508",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "F7GJ+F64, Abdul Haque Rd, Block G1 Block G 1 Phase 1 Johar Town, Lahore, Punjab",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.476154651522258,
      longitude: 74.28058231396972,
      extrafield: "",
      status: 1,
    },
    {
      title: "S.Book Spot",
      description: "Walton Rd, Cavalry Ground, Lahore",
      phone: "+923334756338",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Walton Rd, Cavalry Ground, Lahore, Punjab 54000, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.495936897142457,
      longitude: 74.37443186405112,
      extrafield: "",
      status: 1,
    },
    {
      title: "Abdullah School college Uniform",
      description: "Asif Plaza, Walton Rd, Super Town, Cavalry Ground, Lahore, Punjab",
      phone: "0300 4848017",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Walton Rd, Cavalry Ground, Lahore, Punjab 54000, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.494698649679233,
      longitude: 74.37443755729109,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "101-CCA DD Sector, DHA Phase 4 DHA, Lahore",
      phone: "042 37195988",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "101-CCA DD Sector, DHA Phase 4 DHA, Lahore, 54000",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.463032935845376,
      longitude: 74.3844433889242,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "Boulevard Heights, Hall#2, Mezzanine Floor Main Boulevard Gulberg Block, 2 K, Gulberg, Lahore",
      phone: "03111333042",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Boulevard Heights, Hall#2, Mezzanine Floor Main Boulevard Gulberg Block, 2 K, Gulberg, Lahore, 54000",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.52061130823318,
      longitude: 74.34688199599925,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "85 Block J1 Phase, 2 Johar, Town, Lahore",
      phone: "03111333042",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "85 Block J1 Phase, 2 Johar, Town, Lahore, 54000",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Lahore",
      zipcode: null,
      latitude: 31.469876946930768,
      longitude: 74.24942686078224,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "Plot # 2 B, Main Warsak Rd, I-9 Markaz I 9 Markaz I-9, Islamabad",
      phone: "03225049482",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Plot # 2 B, Main Warsak Rd, I-9 Markaz I 9 Markaz I-9, Islamabad, Islamabad Capital Territory",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.66045477014629,
      longitude: 73.06280139128948,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "Plot# 3 Hospital Boulevard, Sector A DHA Phase II, Islamabad",
      phone: "03111333042",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Plot# 3 Hospital Boulevard, Sector A DHA Phase II, Islamabad, Islamabad Capital Territory 45730",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.52496257522202,
      longitude: 73.14333559391861,
      extrafield: "",
      status: 1,
    },
    {
      title: "The Book Web",
      description: "West Rakh, W Canal Rd, Raza Garden, Faisalabad",
      phone: "0309 1610000",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "F535+JXQ West Rakh, W Canal Rd, Raza Garden, Faisalabad, Punjab 38000",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Faisalabad",
      zipcode: null,
      latitude: 31.45415506015016,
      longitude: 73.15996323686694,
      extrafield: "",
      status: 1,
    },
    // {
    //   title: "Classic Unifrom",
    //   description: "Basement، Sharif plaza, LMQ Rd, Tariqabad, Multan",
    //   phone: "(061) 4545420",
    //   priority: 1,
    //   email: "",
    //   fax: "",
    //   web: "",
    //   webdisplay: "",
    //   tags: "",
    //   schedule: "",
    //   store_image: "",
    //   marker_image: "",
    //   address: "Basement، Sharif plaza, LMQ Rd, Tariqabad, Multan, Punjab 60000",
    //   address2: "",
    //   country: "Pakistan",
    //   state: "",
    //   city: "Multan",
    //   zipcode: null,
    //   latitude: 30.20424315558102,
    //   longitude: 71.4572879610804,
    //   extrafield: "",
    //   status: 1,
    // },
    {
      title: "Naheed Super Market, Malir Cantt Branch",
      description: "Shop # GF 16 & FF 09, Safa Mall, Ziarat line, Malir Cantonment, Karachi",
      phone: "(021) 111 624 333",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Shop # GF 16 & FF 09, Safa Mall, Ziarat line, Malir Cantonment, Karachi, Karachi City, Sindh 75070",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Karachi",
      zipcode: null,
      latitude: 24.942684524460823,
      longitude: 67.20471501534317,
      extrafield: "",
      status: 1,
    },
    {
      title: "New Ghani Sons",
      description: "Old Sunset Boulevard، Phase 2 Gizri, Karachi, 75600",
      phone: "(021) 35384378",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Old Sunset Boulevard، Phase 2 Gizri, Karachi, 75600",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Karachi",
      zipcode: null,
      latitude: 24.8296215,
      longitude: 67.0509191,
      extrafield: "",
      status: 1,
    },
    {
      title: "Naheed Super Market",
      description: "156-157، Main Shaheed-e-Millat Rd, Block 3 BYJCHS, Karachi",
      phone: "(021) 111 624 333",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "156-157، Main Shaheed-e-Millat Rd, Block 3 BYJCHS, Karachi",
      address2: "",
      country: "Pakistan",
      state: "",
      city: "Karachi",
      zipcode: null,
      latitude: 24.877947959213824,
      longitude: 67.06852534331715,
      extrafield: "",
      status: 1,
    },
    {
      title: "Book Mark",
      description: "Shop No, 1 Raiwind Rd, near Yasir Broast, Block C Judicial Colony, Lahore",
      phone: "0311 1760022",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Shop No, 1 Raiwind Rd, near Yasir Broast, Block C Judicial Colony, Lahore, Punjab 54000.",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Lahore",
      zipcode: null,
      latitude: 31.467030556010513,
      longitude: 74.24359275685782,
      extrafield: "",
      status: 1,
    },
    {
      title: "Asif Book & Uniforms",
      description: "Allama Shabbir Ahmed Usmani Rd, Block 3 Gulshan-e-Iqbal, Karachi, Pakistan",
      phone: "03311388890",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Allama Shabbir Ahmed Usmani Rd, Block 3 Gulshan-e-Iqbal, Karachi, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Sindh",
      city: "Karachi",
      zipcode: null,
      latitude: 24.926901116457014,
      longitude: 67.09441322967129,
      extrafield: "",
      status: 1,
    },
    {
      title: "Perfect Stationers Books and Uniform",
      description: "Basement Plot 14B, Ramna Plaza, G-10 Markaz, Islamabad",
      phone: "03328336006",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Basement Plot 14B, Ramna Plaza, G-10 Markaz, Islamabad",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Islamabad",
      zipcode: null,
      latitude: 33.674864657660734,
      longitude: 73.01500206934101,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "8-B Model Town Blvd, Model Town B Block B Model Town, Multan",
      phone: "(061) 2076480",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "8-B Model Town Blvd, Model Town B Block B Model Town, Multan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Multan",
      zipcode: null,
      latitude: 30.245099415946996,
      longitude:   71.4954034144799,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "Main Gol Bagh Road, near Meezan Bank, C Block Gulgasht Colony, Multan.",
      phone: "(061) 6217411",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Main Gol Bagh Road, near Meezan Bank, C Block Gulgasht Colony, Multan.",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Multan",
      zipcode: null,
      latitude: 30.222681041250873,
      longitude: 71.47395584730415,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "7FJX+99X, Basti Okar, Multan, Pakistan",
      phone: "(061) 6217411",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "7FJX+99X, Basti Okar, Multan, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Multan",
      zipcode: null,
      latitude: 30.280973061721948,
      longitude: 71.49861002942501,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "Plot 350, Canal Colony Farid Town, Sahiwal, Pakistan",
      phone: "(040) 4229166",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Plot 350, Canal Colony Farid Town, Sahiwal, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Sahiwal",
      zipcode: null,
      latitude: 30.670800403880634,
      longitude: 73.09350662141357,
      extrafield: "",
      status: 1,
    },
    {
      title: "Reads (The School Shop)",
      description: "9MV6+8HG, Model Town, Bahawalpur, Pakistan",
      phone: "(062) 2882152",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "9MV6+8HG, Model Town, Bahawalpur, Pakistan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Bahwalpur",
      zipcode: null,
      latitude:29.393350305596517,
      longitude: 71.66143488137428,
      extrafield: "",
      status: 1,
    },
    {
      title: "Abdul Rahman Book Bank",
      description: "Plaza no, 10 Bahria Food St, near Nandos, Phase 7 Bahria, Rawalpindi",
      phone: "(051) 8770776",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Plaza no, 10 Bahria Food St, near Nandos, Phase 7 Bahria, Rawalpindi ",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Rawalpindi",
      zipcode: null,
      latitude:33.52873449772707,
      longitude: 73.098167892036,
      extrafield: "",
      status: 1,
    },

    {
      title: "My Bag Pack",
      description: "next to Beaconhouse Palm tree School, Wania Wala, Gujranwala",
      phone: "(055) 3200151",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "next to Beaconhouse Palm tree School, Wania Wala, Gujranwala",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Gujranwala",
      zipcode: null,
      latitude: 32.18585385518492,
      longitude: 74.22670960928194,
      extrafield: "",
      status: 1,
    },
    {
      title: "My Bag Pack",
      description: "Bosan Rd, near Beaconhouse Main Campus, Green Town Multan",
      phone: "(061) 6800915",
      priority: 1,
      email: "",
      fax: "",
      web: "",
      webdisplay: "",
      tags: "Bags",
      schedule: "",
      store_image: "",
      marker_image: "",
      address: "Bosan Rd, near Beaconhouse Main Campus, Green Town Multan",
      address2: "",
      country: "Pakistan",
      state: "Punjab",
      city: "Multan",
      zipcode: null,
      latitude: 30.261121713641824,
      longitude: 71.49053834964604,
      extrafield: "",
      status: 1,
    },
  ];

    // Ensure jQuery is loaded
    jQuery(document).ready(function ($) {
      ensureGoogleMaps(initMap);
    });
    
    // Shopify Turbo Navigation Fix
    document.addEventListener("shopify:section:load", function () {
      ensureGoogleMaps(initMap);
    });
    
    document.addEventListener("shopify:section:reorder", function () {
      ensureGoogleMaps(initMap);
    });
    
    document.addEventListener("turbo:load", function () {
      ensureGoogleMaps(initMap);
    });
      
  
  var destinationsForDistanceMatrix = [];
  var gmarkers = [];
  var geocoder = new google.maps.Geocoder();
  var map;

  var Rand = Math.floor(Math.random() * 100) + 1;
  var items = [];
  $.each(locations, function (key, val) {
    items.push("<li data-store-index='" + key + "'>" + val.title + "</li>");
  });
  $(".stores-list").html(items.join(""));

  setTimeout(() => {
    console.log(locations[0]);
    ensureGoogleMaps(initMap);
    // initMap();
    console.log(locations.length);
    //filterLocations(locations);
    populateLocationsSideBar(locations);
    console.log(locations);
    fillMarkers(locations);

    $("#locationdropdown").on("change", function () {
      var value = $(this).val();
      var listindex;
      var listindexdata;
      var listindexall;
      for (listindex = 0; listindex < locations.length; listindex++) {
        if (locations[listindex].city.toLocaleLowerCase() == value) {
          document.querySelector(".stores-list").innerHTML = " ";
        } else {
          document.querySelector(".stores-list").innerHTML = " ";
        }
      }
      for (
        listindexdata = 0;
        listindexdata < locations.length;
        listindexdata++
      ) {
        if (locations[listindexdata].city.toLocaleLowerCase() == value) {
          document.querySelector(".stores-list").innerHTML +=
            "<li data-store-index='" +
            listindexdata +
            "' data-store-lat='" +
            locations[listindexdata].latitude +
            "' data-store-long='" +
            locations[listindexdata].longitude +
            "'><strong>" +
            locations[listindexdata].title +
            "</strong> <br> " +
            locations[listindexdata].address +
            "<br>" +
            locations[listindexdata].address2 +
            "</li>";
        }
      }
      for (listindexall = 0; listindexall < locations.length; listindexall++) {
        if (value === "all") {
          document.querySelector(".stores-list").innerHTML +=
            "<li data-store-index='" +
            listindexall +
            "' data-store-lat='" +
            locations[listindexall].latitude +
            "' data-store-long='" +
            locations[listindexall].longitude +
            "'><strong>" +
            locations[listindexall].title +
            "</strong> <br> " +
            locations[listindexall].address +
            "<br>" +
            locations[listindexall].address2 +
            "</li>";
        }
      }
    });
  }, 5000);

  // setTimeout(() => {

  //     filterLocations(locations);

  //   }, 5000);

  function ensureGoogleMaps(callback) {
  if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
    callback();
  } else {
    console.error("Google Maps API not loaded yet.");
    setTimeout(() => ensureGoogleMaps(callback), 500);
  }
}
  
  function initMap() {
    console.log("Map API Loaded")
    var centerCoordinates = new google.maps.LatLng(24.9170147, 67.0551122);
    map = new google.maps.Map(document.getElementById("map"), {
      center: centerCoordinates,
      zoom: 15,
    });
    var card = document.getElementById("pac-card");
    var input = document.getElementById("pac-input");
    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.addListener("place_changed", function () {
      codeAddress();
    });
  }

  // Ensure `initMap` is globally available
  window.initMap = initMap;
  

  function filterLocations(tempLocations) {
    console.log(locations);

    // tempLocations = [];
    // tempLocations.push(locations[0]);
    // tempLocations.push(locations[1]);

    // $.each(locations,function(index,object){
    //     console.log(index);
    //     console.log(object);

    //     if(index===1 || index===2){
    //         console.log("coming")

    //     }else{
    //         locations.splice(index,1);
    //     }
    // })

    map.setCenter({
      lat: tempLocations[0].latitude,
      lng: tempLocations[0].longitude,
    });

    //console.log(locations);

    populateLocationsSideBar(tempLocations);
    fillMarkers(tempLocations);
  }

  function populateLocationsSideBar(locations) {
    var items = [];
    counter = 0;
    for (i = 0; i < locations.length; i++) {
      items.push(
        "<li data-store-index='" +
          counter +
          "' data-store-lat='" +
          locations[i].latitude +
          "' data-store-long='" +
          locations[i].longitude +
          "'><strong>" +
          locations[i].title +
          "</strong> <br> " +
          locations[i].address +
          "<br>" +
          locations[i].address2 +
          "</li>"
      );
      counter++;
    }

    $(".stores-list").html(items.join(""));
  }

  function fillMarkers(markers) {
    if (gmarkers.length > 0) {
      gmarkers.forEach(function (marker) {
        marker.setMap(null);
      });
    }

    var infoWindow = new google.maps.InfoWindow();
    for (i = 0; i < markers.length; i++) {
      var data = markers[i];
      var myLatlng = new google.maps.LatLng(data.latitude, data.longitude);

      destinationsForDistanceMatrix.push(myLatlng);

      var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        title: data.title,
        address: data.address,
        address2: data.address2,
        phone: data.phone,
        tags: data.tags,
      });

      gmarkers.push(marker);
      //destinationsForDistanceMatrix.push()

      (function (marker, data) {
        google.maps.event.addListener(marker, "click", function (e) {
          var directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${data.latitude},${data.longitude}`;

          infoWindow.setContent(
            `<div style='min-width:200px !important; max-height:200px; '>
          <strong>${data.title}</strong><br>
              <p onclick="window.open('${directionsUrl}', '_blank')"  style='color:red;'>
            Get Directions
          </p>
          <span>${data.address}<br>${data.address2}</span><br><br>
          <strong>Phone: </strong>${data.phone}<br>
      
        </div>`
          );
          infoWindow.open(map, marker);
        });
      })(marker, data);
    }

    // google.maps.event.trigger(gmarkers[0], 'click');
  }

  function locateStore(index) {
    google.maps.event.trigger(gmarkers[index], "click");
  }

  function codeAddress() {
    var numberOfResults = 14;
    var address = document.getElementById("pac-input").value;
    geocoder.geocode({ address: address }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        map.setCenter(results[0].geometry.location);

        var pt = new google.maps.LatLng(
          results[0].geometry.location.lat(),
          results[0].geometry.location.lng()
        );

        varTempLocations = [];

        for (j = 0; j < locations.length; j++) {
          var distance = getDistanceFromLatLonInKm(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng(),
            locations[j].latitude,
            locations[j].longitude
          );
          if (config.distance_for_filter >= distance) {
            locations[j].distance = distance;
            varTempLocations.push(locations[j]);
          }
        }

        filterLocations(
          varTempLocations.sort((a, b) => (a.distance > b.distance ? 1 : -1))
        );
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  }

  function calculateDistanceByDistanceMatrixService(pt) {
    for (var i = 0; i < locations.length; i++) {
      var service = new google.maps.DistanceMatrixService();
      var request = {
        origins: [pt],
        destinations: [],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false,
      };

      request.destinations = [
        new google.maps.LatLng(locations[i].latitude, locations[i].longitude),
      ];

      service.getDistanceMatrix(request, function (response, status) {
        if (status != google.maps.DistanceMatrixStatus.OK) {
          alert("Error was: " + status);
        } else {
          var results = response;

          for (j = 0; j < results.length; j++) {
            console.log(
              request.destinations[j] +
                " ===== " +
                results[j].distance.text +
                " ==== " +
                results[j].distance.value
            );
          }
        }
      });
    }
  }

  function calculateDistanceByDistanceMatrixService_(pt) {
    var service = new google.maps.DistanceMatrixService();
    var request = {
      origins: [],
      destinations: [],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
      avoidHighways: false,
      avoidTolls: false,
    };

    request.origins.push(pt);

    for (var i = 0; i < locations.length; i++) {
      request.destinations.push(
        new google.maps.LatLng(locations[i].latitude, locations[i].longitude)
      );

      if (i == 24) {
        break;
      }
    }

    console.log(request);

    service.getDistanceMatrix(request, function (response, status) {
      console.log(response);
    });
  }

  function getDistanceFromLatLonInKm(
    latitude1,
    longitude1,
    latitude2,
    longitude2,
    units
  ) {
    var p = 0.017453292519943295; //This is  Math.PI / 180
    var c = Math.cos;
    var a =
      0.5 -
      c((latitude2 - latitude1) * p) / 2 +
      (c(latitude1 * p) *
        c(latitude2 * p) *
        (1 - c((longitude2 - longitude1) * p))) /
        2;
    var R = 6371; //  Earth distance in km so it will return the distance in km
    var dist = 2 * R * Math.asin(Math.sqrt(a));
    //document.getElementById("output").innerHTML = dist+"Km";
    return dist;
  }

  $(document).on("click", ".stores-list li", function () {
    locateStore($(this).attr("data-store-index"));
    map.setCenter({
      lat: parseFloat($(this).attr("data-store-lat")),
      lng: parseFloat($(this).attr("data-store-long")),
    });
  });

  function sortByDistDM(a, b) {
    return a.distance.value - b.distance.value;
  }


  
  /*
  
   https://stackoverflow.com/questions/7883414/google-map-route-single-origin-with-multiple-destinations
   https://medium.com/@wadecarlson/multiple-destinations-with-google-distance-matrix-service-193c63560e70
    */
});
